import { makeVar, ReactiveVar, useReactiveVar } from '@apollo/client';

// ============ INTERFACE ============

export interface ModalState {
  callMeModal: boolean;
  contactModal: boolean;
}

// ============ REACTIVE VARIABLES ============

const initialState: ModalState = {
  callMeModal: false,
  contactModal: false
};

export const modalVar: ReactiveVar<ModalState> = makeVar<ModalState>(initialState);

// ============ ACTIONS ============

export const openCallMeModal = (): void => {
  modalVar({
    ...modalVar(),
    callMeModal: true
  });
};

export const closeCallMeModal = (): void => {
  modalVar({
    ...modalVar(),
    callMeModal: false
  });
};

export const openContactModal = (): void => {
  modalVar({
    ...modalVar(),
    contactModal: true
  });
};

export const closeContactModal = (): void => {
  modalVar({
    ...modalVar(),
    contactModal: false
  });
};

export const useModal = (): ModalState => {
  const modalState = useReactiveVar(modalVar);
  return modalState;
};